module.exports = __webpack_public_path__ + "img/iosmock.3ec65b.png";